
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm6.9 7.5l-7.9 10c-.1.2-.3.3-.5.5-.4.2-.8.4-1.2.4h-.4c-.6-.1-1.1-.4-1.4-.9L5.1 14c-.4-.5-.2-1.2.3-1.6.2-.2.5-.2.8-.2.3.1.6.2.7.5L9.3 16l7.8-9.9c.4-.5 1.1-.6 1.6-.2.2.2.4.5.4.8.1.3 0 .6-.2.8z"}})])
          )
        }
      }
    